import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from '../Topbar';
import Sidebar from '../Sidebar';
import './index.scss';

const DashboardLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="dashboard-layout">
            <Topbar onMenuClick={toggleSidebar} sidebarIsOpen={sidebarOpen} />
            <Sidebar
                isOpen={sidebarOpen}
                onClose={toggleSidebar}
            />
            <main className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-collapsed'}`}>
                <Outlet />
            </main>
        </div>
    );
};

export default DashboardLayout;
